module.exports = __webpack_public_path__ + "static/media/Vector_right.5763bbd1.svg";